import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { RoundByRound } from '../components/round-by-round';

const BrownlowRoundByRoundProvider = ({ store, data }) => (
    <Provider store={store}>
        <RoundByRound {...data} />
    </Provider>
);

BrownlowRoundByRoundProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};

export default BrownlowRoundByRoundProvider;
